"use strict";

Shopify.theme.jsFeaturedArticle = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedArticle = $.extend(this, Shopify.theme.getSectionData($section));

    this.createSlider();
  },
  createSlider: function createSlider() {
    var options = {
        prevNextButtons: true,
        cellAlign: 'center',
        pageDots: true
    };
    
    // enable prev/next buttons at 768px
    if ( matchMedia('screen and (min-width: 798px)').matches ) {
        options.prevNextButtons = false;
        options.pageDots = false;
        options.cellAlign = 'left';
        options.draggable = false;
    }
    
    $('.featured-article-slider').flickity( options );
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};